import { useRouteMatch } from 'react-router-dom';

import { useFetchQueryParams } from '@/hooks/useFetchQueryParams';
import type { RouteParam } from '@/types';

import { useQueryParams } from './useQueryParams';

type UseIsSharedFeed = { isChannel?: boolean };

export const useIsSharedFeed = ({
  isChannel = false,
}: UseIsSharedFeed = {}) => {
  const [query] = useQueryParams();
  const { params } = useRouteMatch<RouteParam>();
  const { channel_id } = useFetchQueryParams();

  return {
    isSharedData:
      !!query?.channel_id ||
      query?.search_type === 'shared_data' ||
      params?.category === 'channels' ||
      !!channel_id ||
      isChannel,
  };
};
